import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DMOperation', 'GPS', 'Reason'],
});

export const tttOperationDashboardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findTTTAllJobsByDatetime: builder.query({
      query: (payload) => {
        let url = `ttt_operation_dashboard/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['DMOperation'],
    }),
    findOrderRealtimeTracking: builder.query({
      query: (payload) => {
        let url = `realtime_trackings/ttt/selection_data/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['DMOperation'],
    }),
    updateReason: builder.mutation({
      query: (data) => {
        let url = `realtime_trackings/reason/${data.id}/`;
        let postData = {
          reason_id: data.reason_id,
          reason_description: data.reason_description,
          reason_version: data.reason_version,
        };
        return { url: url, method: 'PUT', body: postData };
      },
      invalidatesTags: ['Reason'],
    }),
    updateReasonTruckSchedules: builder.mutation({
      query: (data) => {
        let url = `truck_schedules/reason/${data.id}/`;
        let postData = {
          reason_id: data.reason_id,
          reason_description: data.reason_description,
          reason_version: data.reason_version,
        };
        return { url: url, method: 'PUT', body: postData };
      },
      invalidatesTags: ['Reason'],
    }),
    findTTTAllReasonMasters: builder.query({
      query: () => `reasons/`,
      providesTags: ['DMOperation'],
    }),
    findTTTReasonMasterById: builder.query({
      query: (id) => `reasons/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'GPS', id: result.id }] : ['GPS'];
      },
      keepUnusedDataFor: 0, // No cache
    }),
    findGroupReasonByCode: builder.query({
      query: (code) => `reasons/?&subject_reason__group__code=${code}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'DMOperation', id: result.id }]
          : ['DMOperation'];
      },
    }),
    findRealtimeTrackingById: builder.query({
      query: (id) => `ttt_tracking_dashboard/${id}/`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'GPS', id: result.id }] : ['GPS'];
      },
    }),
    deleteRealtimeTrackingById: builder.mutation({
      query: (id) => ({
        url: `ttt_tracking_dashboard/${id}/`,
        method: 'DELETE',
      }),
    }),
    updateTruckSchedules: builder.mutation({
      query: (data) => ({
        url: `truck_schedules/human/${data.id}/`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['GPS'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindTTTAllJobsByDatetimeQuery,
  useFindOrderRealtimeTrackingQuery,
  useUpdateReasonMutation,
  useUpdateReasonTruckSchedulesMutation,
  useFindTTTAllReasonMastersQuery,
  useFindTTTReasonMasterByIdQuery,
  useUpdateTruckSchedulesMutation,
  useFindRealtimeTrackingByIdQuery,
  useDeleteRealtimeTrackingByIdMutation,
} = tttOperationDashboardApi;
